/**
 * Builds URLs for other flows based on current domain
 *
 * Examples:
 * - On refi.waters.ownli.app → insurance.waters.ownli.app
 * - On localhost or other → insurance.ownli.app
 */
export function buildFlowUrl(targetFlow) {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");

  // Check if we're on a partner subdomain pattern (e.g., refi.waters.ownli.app)
  // Pattern: [flow].[partner].ownli.app = 4 parts
  const isPartnerSubdomain =
    parts.length >= 4 && parts[parts.length - 2] === "ownli";

  if (isPartnerSubdomain) {
    // For partner subdomains, use shorter subdomain names
    const PARTNER_SUBDOMAINS = {
      insurance: "insurance",
      warranty: "warranty",
      refinance: "refi",
    };
    const partner = parts[1];
    const domain = parts.slice(2).join("."); // ownli.app
    const newSubdomain = PARTNER_SUBDOMAINS[targetFlow];
    return `https://${newSubdomain}.${partner}.${domain}`;
  }

  // Fallback to main ownli subdomain URLs (use extended-warranty for general)
  const GENERAL_SUBDOMAINS = {
    insurance: "insurance",
    warranty: "extended-warranty",
    refinance: "refinance",
  };
  const newSubdomain = GENERAL_SUBDOMAINS[targetFlow];
  return `https://${newSubdomain}.ownli.app`;
}
